import PropTypes from 'prop-types';
import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { get, flowRight as compose } from 'lodash';

import { QUERY_GET_CONNECTION_TYPES } from './gql';
import withAuth from '../../../../hocs/withAuth';
import { ReactChildrenPropType } from '../../../../lib/commonPropTypes';

class ConnectorType extends React.Component {
  getData = () => {
    const { connectionType, auth } = this.props;
    const connectorConnectionTypes = get(connectionType, 'AdminQueries.getConnectorConnectionTypes', []);

    return {
      connectionType: connectorConnectionTypes,
      admin: auth.me
    };
  };

  getError = () => {
    const { connectionType } = this.props;
    return {
      connectionError: connectionType.error
    };
  };

  getLoading = () => {
    const { connectionType } = this.props;
    return {
      connectionLoading: connectionType.loading
    };
  };

  render() {
    const { children } = this.props;
    const renderProps = {
      data: this.getData(),
      error: this.getError(),
      loading: this.getLoading()
    };
    return children(renderProps);
  }
}

ConnectorType.propTypes = {
  children: ReactChildrenPropType.isRequired,
  connectionType: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.shape({}),
    refetch: PropTypes.func
  }).isRequired,
  auth: PropTypes.shape({
    me: PropTypes.shape({})
  }).isRequired
};

export const ConnectorTypeContainer = compose(
  withAuth(),
  graphql(QUERY_GET_CONNECTION_TYPES, {
    name: 'connectionType',
    options: () => ({
      fetchPolicy: 'cache-and-network'
    }),
    props: (props) => props
  })
)(ConnectorType);
